<template>
  <div>
    <v-dialog class="paper-dialog" :title="data ? 'Update Content' : 'New Content'" :visible.sync="dialogVisible" width="550px"
      @open="onOpen" @close="onClosed">

      <el-form class="padding-lr" ref="form" :model="form" :rules="formRules" label-width="120px">
        <el-form-item label="Category">
          <div class="cate-select-add">
            <el-select placeholder="Please select content category" v-model="form.categoryId">
              <el-option v-for="(item, index) in categoryList" :value="item.PaperCategoryID" :key="index"
                :label="item.CategoryName">
                <div class="select-option-item" :title="item.CategoryName">
                  {{ item.CategoryName }}
                </div>
              </el-option>
            </el-select>
            <el-button icon="el-icon-plus" @click="showCateDialog" />
          </div>
        </el-form-item>
        <el-form-item label="Security Level" prop="levelID">
          <el-select v-model="form.levelID" placeholder="Please select security level">
            <el-option v-for="(item, index) in securityLevels" :label="item.Name" :value="item.Id" :key="index" />
          </el-select>
        </el-form-item>
        <div class="uploadFile" v-if="!data">
          <el-form-item label="Upload File" prop="uploadFile" class="uploadFile">
              <MultipleFileUpload ref="fileUpload" action="/quickPush/uploadFile"
                accept=".PDF,.pdf,.docx,doc,.ppt,.pptx" message="Only PDF, Doc and PPT file can be uploaded"
                @success="handleSuccess" @fail="handleFail" />
              <div class="upload-files">
                <div class="upload-file-item" v-for="(file, i) in files" :key="i">
                  <div class="file-info">
                    <a :href="file.previewUrl" target="_blank" :title="file.originalName">
                      <i class="el-icon-document"></i>
                      {{ file.originalName }}
                    </a>
                    <span @click="deleteFile(i)" style="cursor: pointer;">
                      <i class="el-icon-close"></i>
                    </span>
                  </div>
                  <div class="file-description">
                    <label>Description</label>
                    <el-input
                      v-model="uploadFiles[i].description"
                      type="textarea"
                      :rows="2"
                      placeholder="Please input..."
                      class="description-input"
                      maxlength="500"
              show-word-limit
                      >
                    </el-input>
                  </div>
                </div>
              </div>
          </el-form-item>
        </div>
        <div class="uploadFile" v-else>
          <el-form-item label="Description" class="uploadFile">
              <div class="upload-files">
                <div class="upload-file-item">
                  <div class="file-description">
                    <label>Description</label>
                    <el-input
                      v-model="fileDescription"
                      type="textarea"
                      :rows="3"
                      placeholder="Please input..."
                      class="description-input"
                      maxlength="500"
              show-word-limit
                      >
                    </el-input>
                  </div>
                </div>
              </div>
          </el-form-item>
        </div>

      </el-form>
      <div slot="footer" class="push-footer">
        <el-button plain @click="dialogVisible = false"> Cancel </el-button>
        <el-button type="primary" :loading="loading" @click="onSubmit"> Submit </el-button>
      </div>
    </v-dialog>
    <NewCategoryDialog :visible.sync="addCategoryDialogVisible" @success="onNewCateSuccess" @closed="onNewCateClosed" />
  </div>
</template>
<script>
import NewCategoryDialog from "./category-dialog";
import MultipleFileUpload from "@/components/multiple-file-upload";
import { filesHandler } from "@/utils";
export default {
  name: "new-paper-dialog",
  components: { NewCategoryDialog, MultipleFileUpload },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
    paperContent: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      init: true,
      dialogVisible: this.visible,
      categoryList: [],
      securityLevels: [
        {
          Name: "Green",
          Id: 1,
        },
        {
          Name: "Yellow",
          Id: 2,
        },
      ],
      form: {
        categoryId: null,
        levelID: "",
        uploadFile: ''
      },
      formRules: {
        categoryId: [
          {
            required: true,
            message: "Please select content category",
            trigger: "change",
          },
        ],
        levelID: [
          {
            required: true,
            message: "Please select security level",
            trigger: "change",
          },
        ],
        uploadFile: [
          { required: true, message: "It must be filled", trigger: "blur" },
        ],
      },
      addCategoryDialogVisible: false,
      hidePaperDialog: false,
      uploadFiles: [],
      loading: false,
      fileDescription: ''
    };
  },
  computed: {
    fileName() {
      return this.uploadFile ? this.uploadFile.file.name : null;
    },
    uploadName() {
      return this.uploadFile ? this.uploadFile.fileNameSave : null;
    },
    files() {
      return filesHandler(this.uploadFiles);
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
  },
  methods: {

    onClosed() {
      if (!this.hidePaperDialog) {
        this.uploadFiles = [];
        this.fileDescription = '';
        if (!this.data) {
          this.$refs.fileUpload.reset();
        }
        this.form.categoryId = null;
        this.form.levelID = null
        this.init = true;
        this.$emit("update:visible", false);
        this.$emit("closed");
      }
    },
    onOpen() {
      if(!this.data){
        this.$nextTick(()=>{
          this.$refs.form.resetFields();
        })
      }
      this.form.levelID = null
      this.getCategoryList();
      this.getSecurityLevel();
      if (this.data && this.init) {
        this.form.categoryId = this.data.categoryId
        this.form.levelID = this.data.LevelID
        const rawDesc = this.data.Description || ''
        this.fileDescription = String(rawDesc)
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#x27;/gi, "'")
          .replace(/&#39;/g, "'")
        this.init = false;
      }
    },
    getCategoryList() {
      this.axios.get("/content/categoryList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.categoryList = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    getSecurityLevel() {
      this.axios.get("/content/securityLevel").then(({ code, data, msg }) => {
        if (code === 200) {
          this.securityLevels = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    onSubmit() {
      if (this.data) {
        this.updatePaper();
      } else {
        // 检测是否需要弹出确认提示（只有当前页面传递了paperContent时才检测）
        if (this.paperContent && this.paperContent.trim() !== '') {
          this.$confirm('调整文件后，现有Description将清空，进行重新加载', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.performSubmit();
            this.$emit('clear-description');
          }).catch(() => {
            // 用户取消，不执行提交
          });
        } else {
          this.performSubmit();
        }
      }
    },
    performSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.axios
          .post("/content/addPaper", {
            categoryId: this.form.categoryId,
            levelID: this.form.levelID,
            fileList: this.uploadFiles.map(item => {
              return {
                code: item.code,
                fileName: item.originalName,
                uploadName: item.fileName,
                description: item.description || ''
              }
            }),
          })
          .then(({ code, msg,data }) => {
            this.loading = false;
            if (code == 200) {
              this.$message.success("Create content successfully");
              this.$emit("success", data);
              this.$emit("update:visible", false);
            } else {
              this.$message.error(msg);
            }
          });
      } else {
        return false;
      }
    });
    },
    updatePaper() {
      this.loading = true;
      this.axios.post("/content/updatePaper", {
        paperId: this.data.PaperID,
        categoryId: this.form.categoryId,
        levelID: this.form.levelID,
        description: this.fileDescription
      }).then(({ code, msg }) => {
        if (code == 200) {
          this.$message.success("Update content successfully");
          this.$emit("success", this.uploadFiles);
          this.$emit("update:visible", false);
        } else {
          this.$message.error(msg);
        }
        this.loading = false;
      });
    },
    handleSuccess(files) {
      this.form.uploadFile = files
      this.$refs.form.clearValidate("fileName");
      // Initialize description field for new files
      const filesWithDescription = files.map(file => ({
        ...file,
        description: ''
      }));
      this.uploadFiles = this.uploadFiles.concat(filesWithDescription);
    },
    getFiles() {
      return this.uploadFiles.map((file) => {
        delete file.url;
        return file;
      });
    },
    deleteFile(i) {
      this.uploadFiles.splice(i, 1);
    },
    handleFail() {
      this.$message.error("Upload file failed");
    },
    showCateDialog() {
      this.hidePaperDialog = true;
      this.dialogVisible = false;
      this.addCategoryDialogVisible = true;
    },
    onNewCateSuccess(categoryId) {
      this.getCategoryList();
      this.$set(this.form, 'categoryId', categoryId);
    },
    onNewCateClosed() {
      this.hidePaperDialog = false;
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.paper-dialog {
  ::v-deep .el-dialog__body {
    padding: 0px;
    display: flex;
    max-height: 67vh;
  }

  ::v-deep {
    .el-scrollbar.dialog {
      min-width: unset;
    }
  }
}

::v-deep {
  .select-option-item {
    max-width: 38vw;
  }

  .uploadFile {
    .el-form-item__error {
      padding-top: 6px;
    }

    .el-form-item {
      margin-bottom: 50px !important;
    }
  }
}

.push-footer {
  text-align: center;
}

.el-select+.el-button {
  margin-left: 10px;
}

.padding-lr {
  padding: 0 15px;
}

.el-uploader {
  margin-right: 15px;
}

.upload-file {
  display: inline-flex;
  align-items: center;

  a {
    margin-right: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 300px;
    overflow: hidden;
  }

  span {
    cursor: pointer;
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    color: $theme-color;

    &:hover {
      color: #606266;
    }
  }
}

.el-form-item {
  margin-bottom: 15px !important;

  .el-select,
  .el-input,
  .el-textarea {
    width: 90%;
  }

  &.editor {
    margin-bottom: 0 !important;
    height: 315px;
  }

  .cate-select-add {
    width: 90%;
    display: flex;

    .el-select {
      flex: 1;
    }
  }

  .security-level,
  .right-find {
    margin-top: 5px;
    width: 90%;
    color: #e6a23c;
    line-height: 20px;
    font-size: 12px;
    word-break: break-word;

    &,
    i {
      font-weight: bold;
    }

    i {
      margin-right: 3px;
    }

    a {
      text-decoration: underline;
    }
  }
}

.security-level,
.right-find {
  margin-top: 5px;
  width: 90%;
  color: #e6a23c;
  line-height: 20px;
  font-size: 12px;
  word-break: break-word;

  &,
  i {
    font-weight: bold;
  }

  i {
    margin-right: 3px;
  }

  a {
    text-decoration: underline;
  }
}

.file-description{
  position: relative;
  label{
    position: absolute;
    top:0;
    left:0;
    transform: translateX(calc(-100% - 12px));
  }
}
.file-info{
  margin-top: 10px;
}
</style>
